<template>
  <q-collapsible icon="fa-bell" :label="'Заявка ' + this.lblDate" ref="colpsbl">
    <div>
      <p>
        <small class="tview-label">Пин-код</small>
        <span class="text-bolder">{{request.pin}}</span>
      </p>
      <p>
        <small class="view-label">Клиент</small>
        <span class="text-bolder">{{request.hospital}}</span>
      </p>
      <p>
        <small class="view-label">Место</small>
        <span class="text-bolder">{{request.place}}</span>
      </p>
      <p>
        <small class="view-label">Прибор</small>
        <span class="text-bolder">{{request.analyzer}}</span>
      </p>
      <p>
        <small class="view-label">Проблема</small>
        <span class="text-bolder">{{request.defect}}</span>
      </p>
      <p>
        <small class="view-label">Контакт</small>
        <span class="text-bolder">{{request.person}}</span>
      </p>
      <p>
        <small class="view-label">Телефон</small>
        <span class="text-bolder">{{request.telephone}}</span>
      </p>
    </div>
  </q-collapsible>
</template>

<script type="text/babel">

export default {
  name: 'requestcard',
  props: ['request'],
  data() {
    return {};
  },
  mounted() {
    if (this.$route.name === 'caseNewFromRequest') {
      this.$refs.colpsbl.open();
    }
  },
  computed: {
    lblDate() {
      return this.request.date ? ` от ${this.request.date}` : '';
    },
  },

};
</script>



// WEBPACK FOOTER //
// src/components/request-card.vue